// extracted by mini-css-extract-plugin
export default {"main_button":"MainButton_main_button__o+vr6"};